import React from "react";
import { Route } from "react-router-dom";

const publicRoutes = ({ component: Component, ...rest }) => {
  return <Route {...rest} render={props => <Component {...props} />} />;
};

export default publicRoutes;
